import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isModalOpen"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Text } from 'foundations-components/components/Text';
import { H4 } from 'foundations-components/transitional/components/H4';
import { CodeEntryForm } from './CodeEntryForm';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TwoFactorAuthenticatorForm = _ref => {
  let {
      isModalOpen
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Illustration, {
      name: "mobile-onboarding-account-ready",
      width: "215px"
    }), /*#__PURE__*/_jsx(H4, {
      "aria-level": 1,
      marginBlockStart: "700",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `twoFactorV4.authenticator.title`
      })
    }), /*#__PURE__*/_jsx(Text, {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: `twoFactorV4.authenticator.description`
      })
    }), !isModalOpen && /*#__PURE__*/_jsx(CodeEntryForm, Object.assign({}, props))]
  });
};